import { useTranslation } from "react-i18next";
import styles from "./ReceiptPage.module.scss";
import { getFormConfig } from "./ReceiptPageConfig";
import DynamicForm from "../../components/DynamicForm/DynamicForm";
import Grid from "../../config/Grid/Grid";

function ReceiptPage() {
  const { t } = useTranslation();
  const formConfig = getFormConfig(t);

  return (
    <Grid>
      <div className={`start-1 col-4 ${styles.receiptPageWrapper}`}>
        <div className={styles.receiptPageHeader}>
          <p className={`body-bold-large ${styles.receiptPageHeaderTitle}`}>
            {t("receiptPage.title")}
          </p>
        </div>
        <p className={`title-medium ${styles.receiptPageTitle}`}>
          {t("receiptPage.header.title")}
        </p>
        <DynamicForm {...formConfig} />
      </div>
    </Grid>
  );
}

export default ReceiptPage;
